import template1 from 'assets/images/template1.png';

export const Label1 = () => (
  <div>
    <p>Template 1</p>
    <img src={template1} alt="template1" className="w-50" />
  </div>
);
